import { motion } from "framer-motion";
import { Home, Sparkles, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { PARENTHESES, IMAGES } from "../../data/content";

const ICONS = { hebergement: Home, "bien-etre": Sparkles };
const IMGS = { hebergement: IMAGES.hebergement, "bien-etre": IMAGES.bienEtre };

export const Parentheses = () => {
  return (
    <section
      id="parentheses"
      data-testid="parentheses-section"
      className="relative overflow-hidden bg-pblv-bg2 py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <p className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-pblv-mauve">
              Le réseau
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl font-medium leading-[1.05] tracking-tight text-pblv-ink md:text-6xl">
              T'POZ,
              <br />
              <span className="italic">deux chemins vers soi.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-pblv-inksoft">
              Un temps rien qu'à vous, pensé selon vos besoins. Choisissez le
              repos d'un lieu ressourçant, une expérience de bien-être, ou les
              deux.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-10">
          {PARENTHESES.map((p, i) => {
            const Icon = ICONS[p.key];
            return (
              <Reveal key={p.key} delay={i * 0.12} y={40}>
                <motion.article
                  whileHover={{ y: -8 }}
                  transition={{ type: "spring", stiffness: 240, damping: 20 }}
                  data-testid={`parenthese-card-${p.key}`}
                  className="group flex h-full flex-col overflow-hidden rounded-[2rem] border border-white/60 bg-white shadow-[0_8px_30px_rgba(45,40,48,0.05)]"
                >
                  <div className="pblv-arch relative h-64 md:h-72">
                    <img
                      src={IMGS[p.key]}
                      alt={p.title}
                      className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute left-5 top-5 inline-flex items-center gap-2 rounded-full bg-white/85 px-4 py-2 text-xs font-semibold uppercase tracking-[0.15em] text-pblv-ink backdrop-blur">
                      <Icon className="h-4 w-4 text-pblv-mauve" strokeWidth={1.8} />
                      {p.label}
                    </div>
                  </div>
                  <div className="flex flex-1 flex-col p-8">
                    <h3 className="font-serif text-3xl font-medium text-pblv-ink">
                      {p.title}
                    </h3>
                    <p className="mt-3 text-base leading-relaxed text-pblv-inksoft">
                      {p.body}
                    </p>
                    <ul className="mt-6 flex flex-col gap-3">
                      {p.points.map((point) => (
                        <li
                          key={point}
                          className="flex items-center gap-3 text-sm font-medium text-pblv-ink"
                        >
                          <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-pblv-sage/25 text-pblv-sage">
                            <Check className="h-3.5 w-3.5" strokeWidth={2.5} />
                          </span>
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                </motion.article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Parentheses;
